// src/routes/comingSoonRoutes.jsx
//
// Placeholder routes for upcoming modules. Each one renders the shared
// <ComingSoon /> page with the sprint number + expected date pulled from
// ROADMAP_DASHBOARD.md, so navigation works end-to-end before the real
// pages are built. Replace each <Route> with the real module route file
// once that sprint ships.
//
// All previously-stubbed routes have shipped — Sprint 8 (Settings),
// Sprint 9 (Dashboard home + Reports), and Sprint 10 (Notifications).
// This file is kept as a registration point for future sprints.

import React from 'react';

const comingSoonRoutes = <>{/* No placeholder routes at the moment. */}</>;

export default comingSoonRoutes;
